import { Input, Pagination, Select } from "antd";
import type { PaginationState } from "../../../../model/hooks/use-pagination";
import "./registry-pagination.scss";

interface RegistryPaginationProps {
  pagination: PaginationState;
  total: number;
}

export function RegistryPagination({ pagination, total }: RegistryPaginationProps) {
  const { page, setPage, limit, onLimitChange, jumpPage, setJumpPage, onJump } = pagination;

  return (
    <div className="registry-pagination">
      <div className="registry-pagination__left">
        <Pagination
          current={page}
          pageSize={limit}
          total={total}
          showSizeChanger={false}
          onChange={setPage}
        />
      </div>

      <div className="registry-pagination__right">
        <span className="registry-pagination__label">Перейти к странице</span>
        <Input
          className="registry-pagination__jump"
          value={jumpPage}
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={6}
          onChange={(e) => setJumpPage(e.target.value.replace(/[^\d]/g, ""))}
          onPressEnter={() => onJump(total)}
          onBlur={() => onJump(total)}
        />
        <span className="registry-pagination__label">Актов на странице</span>
        <Select
          className="registry-pagination__size"
          value={limit}
          options={[5, 10, 20, 50, 100].map((v) => ({ value: v, label: v }))}
          onChange={onLimitChange}
        />
      </div>
    </div>
  );
}
